module.exports = __webpack_public_path__ + "static/media/PGS.ea454bb3.png";